import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var BreadcrumbStyle = function BreadcrumbStyle(props) {
  var _getThemeData = getThemeData(props, 'breadcrumb'),
    fontSize = _getThemeData.fontSize,
    lastFontSize = _getThemeData.lastFontSize;
  var _getThemeData2 = getThemeData(props, 'common'),
    primary6 = _getThemeData2.primary6,
    titleColor1 = _getThemeData2.titleColor1,
    titleColor2 = _getThemeData2.titleColor2;
  return css([".c7n-breadcrumb.c7n-breadcrumb{color:", ";font-size:", "px;a,.c7n-breadcrumb-link .icon.icon-more_horiz{color:", ";:hover{color:", ";cursor:pointer;}}& > span:last-child{span{color:", ";font-size:", "px;font-weight:500;}}.icon-arrow_drop_down{font-size:0;}}"], titleColor2, fontSize, titleColor2, primary6, titleColor1, lastFontSize);
};
export default BreadcrumbStyle;